import React from 'react'
import CharacterSpin from './CharacterSpin'

const TextBorder = () => {
  return (
    <div className="textBorderHolder">
        <div className="textBorderLeft">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$2“““““““““““““““““““““““““<br />
          $#a2’<br />
          <CharacterSpin>$</CharacterSpin><CharacterSpin>$</CharacterSpin><br />
          $$<br />
          <CharacterSpin>$</CharacterSpin><CharacterSpin>$</CharacterSpin><br />
          $%<br />
          <CharacterSpin>$</CharacterSpin>s<br />
          $.<br />
          .$<br />
          $.<br />
          <CharacterSpin>i</CharacterSpin><br />
          .<br />
          <CharacterSpin>:</CharacterSpin><br />
          <br />
          <br />
          <CharacterSpin>.</CharacterSpin><br />
          <br />
          <br />
          |<br />
          .<br />      
        </div>

        <div className="textBorderRight">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$2“““““““““““““““““““““““““<br />
          $#a2’<br />
          <CharacterSpin>$</CharacterSpin><CharacterSpin>$</CharacterSpin><br />
          $$<br />
          <CharacterSpin>$</CharacterSpin><CharacterSpin>$</CharacterSpin><br />
          $%<br />
          <CharacterSpin>$</CharacterSpin>s<br />
          $.<br />
          .$<br />
          $.<br />
          <CharacterSpin>i</CharacterSpin><br />
          .<br />
          <CharacterSpin>:</CharacterSpin><br />
          <br />
          <br />
          <CharacterSpin>.</CharacterSpin><br />
          <br />
          <br />
          |<br />
          .<br />      
        </div>
    </div>
  )
}


export default TextBorder